module.exports = {
    "001": 'CAN',
    "002": 'USA'
}